var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAwardIconModal = function SvgAwardIconModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38.5,
    height: 38.5,
    rx: 3.208,
    fill: "#CC092F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.926 16.042a8.676 8.676 0 1 0-14.144 6.73v7.707l14.09-14.437m.054 0h-.054m.054 0h-.054m.054 0a8.663 8.663 0 0 1-3.209 6.73m3.155-6.73a8.609 8.609 0 0 1-3.208 6.704m.053.026v-.026h-.053m.053.026v7.707a.655.655 0 0 1-.946.587l-4.521-2.26m5.467-6.034-.02.016-.033-.042m0 0v7.733a.602.602 0 0 1-.87.539l-4.544-2.212m0 0 .024-.012-.024-.048-.024.048.024.012Zm0 0-4.52 2.26a.654.654 0 0 1-.637-.03l.028-.045 5.129-2.185Zm-.294-1.32-3.864 1.933v-5.767a8.65 8.65 0 0 0 8.315 0v5.767l-3.866-1.932a.654.654 0 0 0-.585 0Zm.294-5.977a5.468 5.468 0 1 0-5.468-5.467 5.473 5.473 0 0 0 5.468 5.467Zm-7.366-5.467a7.366 7.366 0 1 1 7.366 7.366 7.375 7.375 0 0 1-7.366-7.366Zm7.366-4.158a4.157 4.157 0 1 1 0 8.314 4.157 4.157 0 0 1 0-8.314Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.107
  })));
};
export default SvgAwardIconModal;